export const AUTH_ID = "auth-id";
export const AUTH_TOKEN = "auth-token";
export const AUTH_WS_TOKEN = "auth-ws-token";
export const DB_SHARDS = 2;
export const SHARD_NUMBER = "sn";
export const POST_VIEW_TIME = 10;
export const REF_CODE = "ref";
export const PROMO_CODE = "promo";
export const MAINTENANCE_MODE = false;
export const ADMIN_USER_ID = "50a5a756-73e8-414c-9869-160f95d74149";
export const CHAT_ENABLED_COINS_LIMIT = 3000;
export const BASE_CPI = 5;
export const MIN_CONVERSION_AMOUNT = 5000;
export const POST_MAX_LENGTH = 500;
export const BONUS_LEVELS = [10, 30, 70, 150, 310, 630];
//export const BONUS_AMOUNTS = [1, 2, 5, 15, 60, 320];
export const BONUS_AMOUNTS = [3, 6, 15, 45, 180, 960];

export const AD_PLAN_EXTENDED_POST = 3;
export const AD_PLAN_EXTENDED_POST_MAX_LENGTH = 1500;
export const AD_PLAN_HIGHLIGHTED_POST = 3;
export const AD_PLAN_VIDEO = 2;
export const AD_PLAN_CUSTOM_PAGE_REDIRECT_LINK = 1;

// export const GRAPHQL_SERVER_URL =
//   "https://gw-graphql-server-923e68a04224.herokuapp.com";
// export const BACKEND_SERVER_URL =
//   "https://gw-backend-server-7f51918dd144.herokuapp.com";

// HEROKU graphql-server
// export const GRAPHQL_SERVER_URL =
//   process.env.NODE_ENV === "production"
//     ? "https://gw-graphql-server-923e68a04224.herokuapp.com"
//     : "http://localhost:4000";

// // KOYEB graphql-server
// export const GRAPHQL_SERVER_URL =
//   process.env.NODE_ENV === "production"
//     ? "https://front-dulce-gateway-solutions-fe5f1977.koyeb.app"
//     : "https://scalelup-gae.nw.r.appspot.com";

// // GCLOUD graphql-server
// export const GRAPHQL_SERVER_URL =
//   process.env.NODE_ENV === "production"
//     ? "https://scalelup-gae.nw.r.appspot.com"
//     : //?  "https://scalelup-graphql-server-d2d307a6dc80.herokuapp.com"
//       //"http://localhost:4002";
//       "https://scalelup-graphql-server-de5454c4b474.herokuapp.com";

// HEROKU scalelup-graphql-server
export const GRAPHQL_SERVER_URL =
  process.env.NODE_ENV === "production"
    ? "https://scalelup-graphql-server-de5454c4b474.herokuapp.com"
    : "http://localhost:4002";

export const BACKEND_SERVER_URL =
  process.env.NODE_ENV === "production"
    ? "https://gw-backend-server-7f51918dd144.herokuapp.com"
    : "http://localhost:4001";

export const AWS_USER_UPLOAD_URL =
  "https://gw-user-upload-images.s3.eu-west-1.amazonaws.com/";
export const AWS_USER_UPLOAD_RESIZED_URL =
  "https://gw-user-upload-images-resized.s3.eu-west-1.amazonaws.com/";
export const AWS_PROFILE_IMAGES_URL =
  "https://gw-profile-images.s3.eu-west-1.amazonaws.com/";

export const BUNNYNET_VIDEO_THUMBNAIL_DOMAIN =
  "https://vz-1bdcc88f-fa9.b-cdn.net";

export const AWS_ISSUED_INVOICES_URL =
  "https://gw-issued-invoices.s3.eu-west-1.amazonaws.com/";

export const PAYPAL_CLIENT_ID =
  "ARdlotMsvh9PLh55hEfySVO4vaNNrx82yUEVqAwuh_3dyeOwi5RUmOLM6GDq44F6JDcZH7fDdEbhaH5q";
export const PAYPAL_CLIENT_ID_SANDBOX =
  "Ab5n-GdajraAzC4VjOWwOPYlsSKLXFoTKjn3t8dHGhWPby2xuZPk2sqjgA5pDyAOo4rQE83nHxbqUm01";

export const PAGES_DOMAIN_URL =
  process.env.NODE_ENV === "production"
    ? "https://scalelup.net"
    : "http://localhost:5173";
